import React from 'react';
import {isMobile} from 'react-device-detect';
import {stepEnum} from './ChangePricePlanConsts';
import OtpVerificationPageWithImage from '../../Shared/OtpAuthentication/OtpVerificationPageWithImage';
import {gtag4} from '../../../utilities/analytics/tracking';
import {otpOrigin} from '../OTPLoginBlock/Assets/variables';

const OtpStepComponent = ({props}) => {
  let epiTitle, otpBanner, otpBannerMainTitle, otpBannerSecondTitle, blockSource;
  if (props.iContent.otp.value?.length > 0 && props.iContent.otp.expandedValue) {
    epiTitle = props.iContent.otp.expandedValue[0]?.stepOneTitle?.value;

    otpBanner = isMobile
      ? props.iContent.otp.expandedValue[0]?.imageMobile?.value
      : props.iContent.otp.expandedValue[0]?.imageDesktop?.value;

    otpBannerMainTitle = isMobile
      ? props.iContent.otp.expandedValue[0]?.bannerMainTitleMobile?.value
      : props.iContent.otp.expandedValue[0]?.bannerMainTitleDesktop?.value;

    otpBannerSecondTitle = isMobile
      ? props.iContent.otp.expandedValue[0]?.bannerSecondTitleMobile?.value
      : props.iContent.otp.expandedValue[0]?.bannerSecondTitleDesktop?.value;
    blockSource = props.iContent.otp.expandedValue[0]?.blockSource?.value;
  }

  const otpTitles = {
    bannerMainTitle: otpBannerMainTitle,
    bannerSecondTitle: otpBannerSecondTitle,
    verifyPhoneTitle: epiTitle,
    phoneStepButtonText: 'שלחו לי קוד אימות',
    verifyPhoneDescription: 'מה מספר הנייד שלכם?',
    verifyCodeTitle: 'שלחנו קוד אימות, הגיע?',
    otpCodeStepButtonText: 'המשך',
    verifyCodeDescription: 'הקלידו את הקוד שקיבלתם בהודעה',
    blockSource: blockSource,
  };

  const isFromPackage = props.data.selectedMarketPackage ? true : false;

  const goToSelectPackageStep = () => {
    if (props.userData.loginData.isOtpExtendedAuthenticated) {
      props.handleCurrentStep({step: stepEnum.SELECT_ACCOUNT, error: false});
    } else {
      props.handleCurrentStep({step: stepEnum.PACKAGE_SELECT, error: false});
    }
  };

  //Google analytic
  const gaStep1Display = () => {
    gtag4({
      event: isFromPackage ? 'CellPackUpdateP1_Step2_OtpPage' : 'CellPackUpdateP2_Step1_OtpPage',
      step: isFromPackage ? '2' : '1',
      action: 'OtpPage',
      title: epiTitle,
    });
  };
  const gaOnPhoneValidation = () => {
    gtag4({
      event: isFromPackage ? 'CellPackUpdateP1_Step3_OtpPhoneButton' : 'CellPackUpdateP2_Step2_OtpPhoneButton',
      button: otpTitles.phoneStepButtonText,
      step: isFromPackage ? '3' : '2',
      action: 'OtpPhoneButton',
      title: epiTitle,
    });
  };
  const gaStep2Display = () => {
    gtag4({
      event: isFromPackage ? 'CellPackUpdateP1_Step4_OtpCodePage' : 'CellPackUpdateP2_Step3_OtpCodePage',
      button: otpTitles.otpCodeStepButtonText,
      step: isFromPackage ? '4' : '3',
      action: 'OtpCodePage',
      title: otpTitles.verifyCodeTitle,
    });
  };
  const gaOnOtpCodeValidation = () => {
    gtag4({
      event: isFromPackage ? 'CellPackUpdateP1_Step5_OtpButtonClick' : 'CellPackUpdateP2_Step4_OtpButtonClick',
      button: otpTitles.otpCodeStepButtonText,
      step: isFromPackage ? '5' : '4',
      action: 'OtpButtonClick',
      title: otpTitles.verifyCodeTitle,
    });
  };

  return (
    <div className={`${!epiTitle ? 'pt-5' : ''} m-auto`}>
      <OtpVerificationPageWithImage
        otpOrigin={otpOrigin.GENERIC}
        originProcess={otpTitles.blockSource}
        otpTitles={otpTitles}
        onAuthenticatedAction={goToSelectPackageStep}
        isInline={false}
        otpBanner={otpBanner}
        gaStep1Display={gaStep1Display}
        gaOnPhoneValidation={gaOnPhoneValidation}
        gaStep2Display={gaStep2Display}
        gaOnOtpCodeValidation={gaOnOtpCodeValidation}
      />
    </div>
  );
};

export default OtpStepComponent;
